import { Size } from '@ps/web-core-store';
import React from 'react';

import BaseModal from '@swf/components/StarsModal/BaseModal';

import styles from '../Events.scss';

import type { EventDetails as Details, ModalType } from './EventDetailsTable';
import EventDetails from './modals/Details';
import EventPayouts from './modals/Payouts';
import EventSeatDraw from './modals/SeatDraw';

export interface EventModal {
  type: ModalType;
  item: Details;
  onClose: () => void;
}

const EventDetailsModal: React.FC<EventModal> = ({ type, item, onClose }) => {
  const getDetailsModal = (type: string) => {
    switch (type) {
      case 'Details':
        return <EventDetails {...item} onClose={onClose} />;
      case 'SeatDraw':
        return <EventSeatDraw {...item} onClose={onClose} />;
      case 'Prize':
        return <EventPayouts {...item} onClose={onClose} />;
      case 'Winner':
        return <EventPayouts fullInfo {...item} onClose={onClose} />;
    }
  };

  return (
    <BaseModal className={styles.eventPopup} isOpen={true} size={Size.LARGE} closeOnOverlayClick>
      {getDetailsModal(type)}
    </BaseModal>
  );
};

export default EventDetailsModal;
